import '../sass/blocks.scss';

// Blocks
// import './gutenberg/blocks/heading-with-icon';
// import './gutenberg/blocks/dos-and-donts';
import './carousel/content-with-image-slider.js';
import './carousel/hero-slider.js';
import './tabs/tabs.js';
import './tabs/tabs_block.js';
import './acm-quiz/acm-quiz.js';
import './acm-quiz/acm-quiz-block.js';
